import styles from "./Loader.module.scss";

const Loader = () => {
  return (
    <div className={styles.loaderFullScreen}>
      <div className={styles["loader-big"]} />
    </div>
  );
};

export default Loader;
